import React from "react";
import "./Terms.css";

function Terms() {
    return (
        <div className="terms-page">
            <div className="terms-container">

                <h1>Terms & Conditions</h1>

                <p className="intro">
                    Welcome to <strong>TIK HR Consultancy</strong>. These Terms &
                    Conditions govern your access to and use of our website, services,
                    training programs, placement assistance, career guidance, and any
                    other services offered by TIK HR Consultancy.
                </p>

                <p className="intro">
                    By accessing our website or enrolling in any of our services, you
                    agree to comply with these Terms & Conditions. If you do not agree
                    with these Terms, please refrain from using our services.
                </p>

                <section>
                    <h2>Services Offered</h2>

                    <p>
                        TIK HR Consultancy provides professional career development
                        services, including but not limited to:
                    </p>

                    <ul>
                        <li>Career Counselling</li>
                        <li>Training Programs</li>
                        <li>Skill Development</li>
                        <li>Placement Assistance</li>
                        <li>Resume Building</li>
                        <li>Interview Preparation</li>
                        <li>Corporate Recruitment</li>
                        <li>Campus Hiring</li>
                        <li>Internship Assistance</li>
                        <li>Overseas Career Guidance (where applicable)</li>
                    </ul>

                    <p>
                        The scope of services may change from time to time without prior
                        notice.
                    </p>
                </section>

                <section>
                    <h2>Candidate Eligibility</h2>

                    <p>To use our services, candidates must:</p>

                    <ul>
                        <li>Be at least 18 years of age or have parental/legal guardian consent.</li>
                        <li>Provide accurate personal information.</li>
                        <li>Submit genuine educational and identity documents.</li>
                        <li>Cooperate during the recruitment and training process.</li>
                    </ul>

                    <p>
                        Providing false or misleading information may result in immediate
                        termination of services.
                    </p>
                </section>

                <section>
                    <h2>Training Programs</h2>

                    <p>Candidates enrolling in our training programs agree to:</p>

                    <ul>
                        <li>Attend scheduled sessions regularly.</li>
                        <li>Complete assignments and assessments.</li>
                        <li>Maintain discipline and professional conduct.</li>
                        <li>Follow all instructions provided by trainers.</li>
                    </ul>

                    <p>
                        Failure to comply may lead to suspension or termination of training
                        without any liability on the part of TIK HR Consultancy.
                    </p>
                </section>

                <section>
                    <h2>Placement Assistance</h2>

                    <p>
                        TIK HR Consultancy provides placement assistance by connecting
                        candidates with potential employers.
                    </p>

                    <p>However:</p>

                    <ul>
                        <li>We do not guarantee employment.</li>
                        <li>We do not guarantee any specific company.</li>
                        <li>We do not guarantee any specific salary package.</li>
                        <li>Final hiring decisions rest solely with the recruiting company.</li>
                    </ul>

                    <p>Selection depends on:</p>

                    <ul>
                        <li>Candidate qualifications</li>
                        <li>Technical skills</li>
                        <li>Communication skills</li>
                        <li>Interview performance</li>
                        <li>Employer requirements</li>
                        <li>Background verification</li>
                        <li>Market demand</li>
                    </ul>
                </section>

                <section>
                    <h2>Candidate Responsibilities</h2>

                    <ul>
                        <li>Submit accurate information.</li>
                        <li>Maintain confidentiality of training materials.</li>
                        <li>Behave professionally during training and interviews.</li>
                        <li>Attend interviews scheduled through placement assistance.</li>
                    </ul>

                    <p>Failure to comply may result in discontinuation of services.</p>
                </section>

                <section>
                    <h2>Intellectual Property</h2>

                    <p>
                        All logos, training materials, videos, documents, graphics, text,
                        designs and course content are the exclusive intellectual property
                        of TIK HR Consultancy.
                    </p>

                    <p>
                        No content may be copied, reproduced, distributed or commercially
                        used without prior written permission.
                    </p>
                </section>

                <section>
                    <h2>Confidentiality</h2>

                    <ul>
                        <li>Course materials</li>
                        <li>Company processes</li>
                        <li>Internal documents</li>
                        <li>Employer information</li>
                    </ul>

                    <p>
                        Unauthorized disclosure may lead to legal action.
                    </p>
                </section>

                <section>
                    <h2>Third-Party Services</h2>

                    <p>
                        Our website may contain links to third-party websites or services.
                    </p>

                    <ul>
                        <li>Content</li>
                        <li>Privacy practices</li>
                        <li>Availability</li>
                        <li>Policies</li>
                    </ul>

                    <p>Users access third-party websites at their own risk.</p>
                </section>

                <section>
                    <h2>Website Availability</h2>

                    <ul>
                        <li>Maintenance</li>
                        <li>Technical issues</li>
                        <li>Internet outages</li>
                        <li>Server failures</li>
                        <li>Force majeure events</li>
                    </ul>
                </section>

                <section>
                    <h2>Limitation of Liability</h2>

                    <ul>
                        <li>Failure to obtain employment</li>
                        <li>Rejection by employers</li>
                        <li>Salary negotiations</li>
                        <li>Delay in recruitment</li>
                        <li>Technical issues</li>
                        <li>Loss of opportunity</li>
                        <li>Business interruption</li>
                        <li>Indirect or consequential damages</li>
                    </ul>
                </section>

                <section>
                    <h2>Indemnification</h2>

                    <p>
                        Users agree to indemnify and hold harmless TIK HR Consultancy from
                        any claims, liabilities, damages, expenses or legal costs arising
                        from misuse of our services or violation of these Terms.
                    </p>
                </section>

                <section>
                    <h2>Suspension or Termination</h2>

                    <ul>
                        <li>False documents are submitted.</li>
                        <li>Fraudulent activities are detected.</li>
                        <li>Violation of these Terms.</li>
                        <li>Misconduct during training or recruitment.</li>
                    </ul>
                </section>

                <section>
                    <h2>Modification of Terms</h2>

                    <p>
                        TIK HR Consultancy reserves the right to modify these Terms &
                        Conditions at any time. 
                    </p>
                    <p>
                        Updated versions become effective immediately upon publication.
                    </p>
                </section>

                <section>
                    <h2>Governing Law</h2>

                    <p>
                        These Terms shall be governed by the laws of India.</p>
                    <p>
                        Any disputes shall be subject to the exclusive jurisdiction of 
                        the competent courts located in Chennai, Tamil Nadu.
                    </p>
                </section>

            </div>
        </div>
    );
}

export default Terms;